import Skeleton from './Skeleton';

type FormSkeletonProps = {
  fieldCount?: number;
  columnClassName?: string;
  fieldHeight?: number;
};

const FormSkeleton = ({ fieldCount = 4, columnClassName = 'col-12', fieldHeight = 44 }: FormSkeletonProps) => (
  <div aria-busy="true" className="row g-6">
    <output className="visually-hidden">Carregando formulário...</output>
    {Array.from({ length: fieldCount }, (_, fieldIndex) => (
      <div key={fieldIndex} className={columnClassName}>
        <Skeleton className="d-block mb-3" height={16} width="40%" />
        <Skeleton className="d-block rounded" height={fieldHeight} />
      </div>
    ))}
  </div>
);

export default FormSkeleton;
